module.exports = __webpack_public_path__ + "static/img/top_bg.40bb19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top_bg.png
// module id = 7xfe
// module chunks = 1